var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "story-maker-sticker-menu-post" }, [
    _c("div", { staticClass: "header-menu" }, [
      _c("p", [_vm._v(_vm._s(_vm.$t("dash.post-creator.story.post-title")))]),
    ]),
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "form" }, [
        _c("div", { staticClass: "container-input" }, [
          _c("div", { staticClass: "input input-link" }, [
            _c("i", { staticClass: "fa-regular fa-link" }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.models.link,
                  expression: "models.link",
                },
              ],
              attrs: {
                placeholder: _vm.$t("dash.post-creator.story.url-placeholder"),
              },
              domProps: { value: _vm.models.link },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.models, "link", $event.target.value)
                },
              },
            }),
          ]),
          _c("p", { staticClass: "error" }, [_vm._v(_vm._s(_vm.error))]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "button", on: { click: _vm.finish } },
        [
          _vm.isLoading
            ? [_c("i", { staticClass: "fa-sharp fa-solid fa-spinner-third" })]
            : [
                _vm._v(
                  "\n               " +
                    _vm._s(_vm.$t("dash.post-creator.story.add-button")) +
                    "\n            "
                ),
              ],
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }